import React, { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import Image from '@base/lib/ThemeImage';
import { IconPoints } from '@pro/common/IconPoints';
import { ITaskItem, TaskAction } from 'base/interfaces/product';
import { useTrans } from 'base/utils/i18n';

type ITaskItemProps = {
    task: ITaskItem;
}

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const GoButton: FC<ITaskItemProps> = (props) => {
    const { task } = props
    const { t } = useTrans();

    const {
        link,
        taskAction
    } = task

    if (taskAction === TaskAction.None) {
        return null
    }

    return  (
        <Button
            target={isPhone ? '_self': '_blank'}
            type={'primary'}
            size={'small'}
            href={link}
        >{t('web_common_go_upper')}</Button>
    )
}

const ItemM: FC<ITaskItemProps> = (props) => {
    const { task } = props

    return (
        <div className={'g-task-item flex flex-justify flex-middle text-left'}>
            <div className={'g-icon'}>
                <Image
                    src={task.icon}
                    width={24}
                    height={24}
                    fixed
                    background={false}
                />
            </div>
            <div className={'flex-1'}>
                <div className={'g-name'}>
                    {task.taskName}
                </div>
                <div className={'g-points flex flex-middle'}>
                    <IconPoints className={'g-points-icon'} size={18}/>
                    <span>{task.points}</span>
                </div>
            </div>

            <div className={'g-go-button'}>
                <GoButton task={task}/>
            </div>
        </div>
    )
}


const ItemPc: FC<ITaskItemProps> = (props) => {
    const { task } = props

    return (
        <div className={'g-item-container'}>
            <div className={'g-task-item flex flex-1 flex-vertical flex-justify'}>
                <div>
                    <div className={'g-icon'}>
                        <Image
                            src={task.icon}
                            width={32}
                            height={32}
                            fixed
                            background={false}
                        />
                    </div>
                    <div className={'g-name'}>
                        {task.taskName}
                    </div>
                </div>

                <div className={'flex flex-middle flex-justify'}>
                    <div className={'g-points flex flex-middle'}>
                        <IconPoints className={'g-points-icon'} size={22}/>
                        <span>{task.points}</span>
                    </div>
                    <div className={'g-go-button'}>
                        <GoButton task={task}/>
                    </div>
                </div>
            </div>
        </div>
    )
}


const ShareTaskItem: React.FC<ITaskItemProps> = (props) => {

    const {
        task
    } = props

    if (isPhone) {
        return <ItemM task={task}/>
    }
    return (
        <ItemPc task={task}/>
    )
};

export default ShareTaskItem